const _ = require('underscore');
// const Cookies = require('js-cookie');

// require('jquery-form');
const utils = require('../utils');

const imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin( $ );
window.imagesLoaded = imagesLoaded;

const AOS = require('aos');

const AppView = Backbone.View.extend({
	el: $('body')[0],
	didScroll: true,
	lastScrollTop: 0,
	// nice: false,
	initialize() {
		let _this = this;
		
		$(window).on('scroll', _.bind(this._onWindowScroll, this));				
		$(window).smartresize(_.bind(this._onWindowResize, this));				

		_this.$el.on('page:loaded', _.bind(this._onPageLoaded, this));		

		_this.relatedSliderOptions = {
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			fade: false,
			dots: false,
			arrows: true,
			centerMode: false,
			// autoplay: false,
			// speed: 1200,
			// autoplaySpeed: 5000,
			// pauseOnHover: false,
			// rows: 0
			// slide: 'article'
			nextArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><span class="icon-arrow-right"></span></button>',
			prevArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><span class="icon-arrow-left"></span></button>',

			responsive: [
			    
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1
			      }
			    },
			    // {
			    //   breakpoint: 480,
			    //   settings: {
			    //     slidesToShow: 1,
			    //     slidesToScroll: 1
			    //   }
			    // }
			    // You can unslick at a given breakpoint now by adding:
			    // settings: "unslick"
			    // instead of a settings object
  			]
		}

		$('#content').imagesLoaded().always(function(){
			AOS.init({
				// delay: 75,
				// offset: 100,
				// duration: 700,
				once: true,
			// 	mirror: true,
				easing: 'ease-out-quad'
			});
		})

		


	},

	_onPageLoaded(e) {
		$('body').addClass('loaded');
		$('#content').animate({opacity: 1}, {duration: 100});
		
	},

	events: {

		'click .gallery-grid-toggle' 						: '_galleryGridToggleHandler',
		'click .gallery-item-thumb a'						: '_galleryThumbClickHandler',
		'click .explore-main-caption .close-caption' 		: '_galleryCaptionCloseClickHandler',
		
		// 'click .cookies-popup .accept'								: '_cookieModalAcceptClickHandler',
		'click .scroll-to'											: '_scrollToClickHandler',
		'click #hambuger-btn'										: '_toggleMenu',
		'click .search-btn-toggle'									: '_searchBtnToggle',
		'click .close-search'										: '_searchBtnToggle',
		'click a.expand'											: '_toggleSubnavHandler',

		// 'focus .newsletter-form-container form input'				: '_focusCTAOptinFormHandler',
		// 'submit .newsletter-form-container form'					: '_newsletterFormSubmitHandler',

		// 'change .label-checkbox input'								: '_checkBoxInputToggle',

		// 'click *': '_touchTest'
		'click .play-video'											: '_playVideoClickHandler',
		'click a.jump-to'											: '_jumpToClickHandler',

		'click .scroll-psn'	:  '_scrollPsnHandler',

	},

	_searchBtnToggle(e) {
		e.preventDefault()

		$('body').toggleClass('ui-search-mode-on')

		if ( $('body').hasClass('ui-search-mode-on') ) {
			$('#s').trigger('focus')
		}

		return false
	},

	_scrollPsnHandler(e) {
		e.preventDefault($('.page-sections-nav.ui-scroll .scroll-wrap')[0].scrollLeft ? 0 : 500)
		// var sl = $('.page-sections-nav.ui-scroll').scrollLeft()
		$('.page-sections-nav.ui-scroll .scroll-wrap').scrollTo($('.page-sections-nav.ui-scroll .scroll-wrap')[0].scrollLeft ? 0 : 500, {
			  axis: 'x',
			  duration: 400,
			  onAfter: function() {
			  	if ( $('.page-sections-nav.ui-scroll .scroll-wrap')[0].scrollLeft ) {
			  		$('.scroll-psn').html(`<span class="icon-arrow-left"></span>&nbsp;Less`)
			  	} else {
			  		$('.scroll-psn').html(`More <span class="icon-arrow-right"></span>`)
			  	}
			  	
			  }
			})
	},

	_toggleSubnavHandler(e) {
		e.preventDefault()

		const _this = this

		let $a = $(e.currentTarget),
			$li = $a.parent(),
			$subnav = $('.submenu', $li),
			$arrow = $('span[class*="icon"]', $a)

		if ( $subnav.length ) {
			$li.toggleClass('subnav-open')
		} 

		if ( $li.hasClass('subnav-open') ) {
			$arrow.attr('class', $arrow.data('class-off')) 
		} else {
			$arrow.attr('class', $arrow.data('class-on')) 
		}

		return false
	},	

	_jumpToClickHandler(e) {
		e.preventDefault();
		var $a = $(e.currentTarget),
			target = $a.attr('href'),
			offset = $a.attr('data-offset') ? parseInt($a.attr('data-offset')) : 40;
		var url_parts = target.split('#');
		if ( url_parts.length = 2 )
		{
			setTimeout(function(){
				window.location.hash = '#' + url_parts[1];	
			}, 400);
			// Backbone.history.navigate(url_parts[0].replace(Site.baseURL, '') + '#' + url_parts[1], false);
			// var url = Backbone.history.fragment;
			// var to = (url.replace(Site.baseURL, '') + '#' + url_parts[1]);
			// Backbone.history.navigate(to, false);
		}
		$('body').scrollTo( target, 400, {
			offset: -offset
		});
		return false;
	},

	_galleryCaptionCloseClickHandler(e) {
		e.preventDefault()

		$(e.currentTarget).closest('.gallery-item').addClass('caption-closed')

	},

	_galleryGridToggleHandler(e) {
		e.preventDefault()

		let $a = $(e.currentTarget),
			$galleryWrap = $a.closest('.page-section-gallery')

		$galleryWrap.toggleClass('grid-view-on')

		$('.media-gallery').slick('refresh')

		return false

	},
	_galleryThumbClickHandler(e){
		e.preventDefault()

		const 
			_this = this,
			$a = $(e.currentTarget),
			$galleryWrap = $a.closest('.page-section-gallery')

		let pos = parseInt($a.data('gallery-item')) - 1
		
		// console.log(pos)

		$galleryWrap.find('.media-gallery')[0].slick.slickGoTo(pos)
		$galleryWrap.removeClass('grid-view-on')


		return false
	},

	_playVideoClickHandler(e) {

		e.preventDefault();

		let $a = $(e.currentTarget),
			parent = $a.parents('.video-container-wrap')

        parent.addClass('active');

        var iframe = $('iframe', parent)

        // if(getType == 'youtube') {
        iframe[0].src += "&autoplay=1&showinfo=0&controls=1&rel=0&enablejsapi=1";

        // } else if(getType == 'vimeo'){
        //     $("#"+target+" iframe")[0].src += "?autoplay=1&showinfo=0&controls=1&rel=0";
        // }                    
        
	},

	_scrollToClickHandler(e) {
		e.preventDefault();
		
		const $a = $(e.currentTarget),
			href = $a.attr('href'),
			offset = $a.attr('data-offset') ? -$a.attr('data-offset') : 0
		
		if ( $a.parent().hasClass('top-link') )
		{
			$('body').scrollTo(0, {
				duration: 600,
				offset: offset
			});
		} else
		if ( $(href).length ) {
			this.$el.scrollTo(href, {
				duration: 400,
				offset: offset
			});
		}

		return false;
	},
	


	_touchTest(e) {
		e.preventDefault();
		let $el = $(e.currentTarget);
		console.log($el)
		alert($el.attr('class'));
		return false;
	},		


	_toggleMenu(e) {
		let _this = this
		_this.$el.toggleClass('ui-nav-active')

		return false
	},


	

    
	loading( status ) {
		let _this = this;
		if ( status )
		{
			// siteLoading = true;
			// setTimeout(function(){
				// _this.$el.removeClass('loading page-is-changing');
			// }, 1400);
			$('body').removeClass('loaded').addClass('loading');
			
			// _this.$el.removeClass('loaded').addClass('loading page-is-changing');
		} else {
			// $('body').removeClass('loading');
			// _this.$el.removeClass('loading').removeClass('page-is-changing');
			// siteLoading = false;
		}
	},

	
    components( dontScroll ) {

    	let _this = this;

    	$('a.blank').attr('target', '_blank')

    	$('li.blank > a').attr('target', '_blank')
    	
    	// $('li.blank > a').attr('target', '_blank');

		$('body').removeClass('loading');

	    $('#content').imagesLoaded().done(function(){
    		$(window).trigger('resize')
	    })


	    // var tag = document.createElement('script');
     //    tag.src = "//www.youtube.com/iframe_api";
     //    var firstScriptTag = document.getElementsByTagName('script')[0];
     //    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		$('iframe').each(function(){
			if ( $(this).data('src') ) {
				$(this).attr('src', $(this).data('src') );
			}
		})
		
    }, // end components()
    

	render() {
		let _this = this;

		$(window).trigger('resize');

		// $(window).scroll(function(){
			
		// });

	},

	updateTitle( html ) {
		let $tmp = $('<div>')

		if (html && html.length ) {

            let matches = html.match(/<title>(.*?)<\/title>/),
            	parser = new DOMParser(),
            	doc = parser.parseFromString(html, "text/html"),
            	docClass = doc.body.getAttribute('class')

            if (matches && matches.length > 1 && matches[1]) {
                document.title = decodeHTMLEntities(matches[1]);
            }

            
            // Your class(es)
            // Garbage collection, you don't need this anymore.
            // parser = doc = null;
            //$('body').attr('class', docClass);
            
            $tmp.html(html);

            if ( $tmp.find('#main-nav').length ) {
	        	$('#main-nav').html(  $tmp.find('#main-nav').html() );	
	        }
        }
        


    },       

	_onWindowScroll: function(){
		var 
			_this = this,
			st = $(window).scrollTop();
		// _this.didScroll = true;
	},

	_onWindowResize: function(){
		var w = $(window).width(),
			h = $(window).height(),
			_this = this;


		var z = parseInt(w / 100);


		// page section nav
		let psn_w = 0
		$('.page-sections-nav li').each(function(){
			psn_w += $(this).outerWidth(true)
		})

		if ( w >= 768 && $('.page-sections-nav').width() < psn_w ) {
			$('.page-sections-nav').addClass('ui-scroll')
		} else {
			$('.page-sections-nav').removeClass('ui-scroll')
		}
		

		$('.image-thumb, .video-container').each( (index, el) => {
			
			let $el = $(el)
			// console.log($el)
			if ( $el.hasClass('ratio-3-2') ) {
				$el.height( $el.width() * 2/3 )
			}

			if ( $el.hasClass('ratio-1-1') ) {
				$el.height( $el.width() * 1 )
			}

			if ( $el.hasClass('ratio-1-1') ) {
				$el.height( $el.width() * 1 )
			}

			if ( $el.hasClass('ratio-3-4') ) {
				$el.height( $el.width() * 4/3 )
			}

			if ( $el.hasClass('ratio-4-3') ) {
				$el.height( $el.width() * 3/4 )
			}

			if ( $el.hasClass('ratio-16-9') ) {
				$el.height( $el.width() * 9 / 16 )
			}

			if ( $el.data('src') && !$el.hasClass('rendered') ) { 
				let src = $el.data('src')
				$el.css({
					'background-image': `url(${src})`
				})
				$el.addClass('rendered')
			}

		})

		$('.product-gallery-wrap').each(function(){
			$(this).parent().css({minHeight: $(this).height() + 'px'})
		})
 
		$('.bg-resize').each(function(){
			var $imgs = $('img, video, iframe', this); 
			var $container = $(this);
			$imgs.each(function(){

				var $img = $(this),
					imgOriginalWidth = $img.attr('data-width'),
					imgOriginalHeight = $img.attr('data-height'),
					containerWidth = $container.width(),
					containerHeight = $container.height(),
					newW = 0,
					newH = 0,
					offsetTop = 0,
					offsetLeft = 0;
				if ( imgOriginalWidth && imgOriginalHeight )
				{
					var imgOriginalRatio = imgOriginalHeight / imgOriginalWidth;
					newW = containerWidth;
					newH = newW * imgOriginalRatio;
					if ( $img.closest('.bg-resize').hasClass('bg-fit') )
					{
						if ( newH > containerHeight )
						{
							newH = containerHeight;
							newW = newH / imgOriginalRatio;
							offsetLeft = parseInt( ( - newW + containerWidth ) / 2 );
						} else {
							offsetTop = parseInt( ( - newH + containerHeight ) / 2 );
						}	
						$img.css({
							width: newW + 'px',
							height: newH + 'px',
							// marginLeft: offsetLeft + 'px',
							// marginTop: ( offsetTop < 0 ? offsetTop : offsetTop ) + 'px'
						});
					} else {
						if ( newH < containerHeight )
						{
							newH = containerHeight;
							newW = newH / imgOriginalRatio;
							offsetLeft = parseInt( ( - newW + containerWidth ) / 2 );
						} else {
							offsetTop = parseInt( ( - newH + containerHeight ) / 2 );
						}	
						
						$img.css({
							width: newW + 'px',
							height: newH + 'px',
							marginLeft: offsetLeft + 'px',
							marginTop: ( offsetTop < 0 ? offsetTop : offsetTop ) + 'px'
						});
					}
					// console.log($img)

					$img.hasClass('loaded') || $img.addClass('loaded')
					
				}
			})
			
			
		})

	}

})

module.exports = AppView;